module.exports = {
  "$id": "forgetPasswordInfo",
  "type": "object",
  "properties": {
    "accountInput": {
      "title": "账号值",
      "type": "string"
    },
    "infoValue": {
      "title": "信息值",
      "type": "string"
    }
  },
  "required": [
    "accountInput",
    "infoValue"
  ],
  "errorMessage": {
    "accountInput": {
      "message": "请输入正确的用户名/手机号/邮箱",
      "required": "请输入用户名/手机号/邮箱"
    },
    "infoValue": {
      "message": "请输入正确的姓名",
      "required": "请输入姓名"
    }
  }
}
